import { AgGridReact } from 'ag-grid-react';

import { WithLocalStorage } from '@/components';
import { useDefaultGridOptions } from '@/grid';
import { defaultColDef } from '@/grid/defaults';

import { useProceduresColDefs } from '../utils/columnDefs';

type Props = {
  mode?: string;
  rowData: any[] | null;
};

export const ProcedureGrid = ({ mode, rowData }: Props) => {
  const defaultGridOptions = useDefaultGridOptions();
  const proceduresColDefs = useProceduresColDefs();
  return (
    <div className="aspiration__procedure-grid">
      <WithLocalStorage storageKey="aspiration-procedure-grid">
        <AgGridReact
          gridOptions={defaultGridOptions}
          className={`ag-theme-transova${mode === 'dark' ? '-dark' : ''}`}
          rowData={rowData || null}
          defaultColDef={defaultColDef}
          columnDefs={proceduresColDefs}
          rowSelection="single"
          getRowId={(params) => params.data.id}
        />
      </WithLocalStorage>
    </div>
  );
};
